import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/oraya-api";
import { StatusPill } from "@/admin/adminUi";

const STATUSES = ["New", "In Review", "Contacted", "Closed"];

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/admin/contact-submissions").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/contact-submissions/${id}`, { status });
    toast.success("Status updated");
    setItems((arr) => arr.map((x) => (x.id === id ? { ...x, status } : x)));
    setSelected((s) => (s && s.id === id ? { ...s, status } : s));
  };

  const shown = filter === "All" ? items : items.filter((x) => x.status === filter);

  return (
    <div>
      <h1 className="display text-3xl font-light text-oraya-mist">Enquiries</h1>
      <p className="text-oraya-slate mt-1">Contact form submissions.</p>

      <div className="flex flex-wrap gap-2 mt-6 mb-6">
        {["All", ...STATUSES].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`enq-filter-${s.replace(/\s+/g, "-").toLowerCase()}`}
            className={`px-3 py-1.5 rounded-full text-xs transition-colors ${filter === s ? "bg-oraya-mist text-oraya-black" : "glass-medium text-oraya-slate hover:text-oraya-mist"}`}>{s}</button>
        ))}
      </div>

      <div className="bg-oraya-graphite border border-white/[0.06] rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-oraya-slate border-b border-white/[0.06]">
            <th className="px-6 py-4 font-medium">Name</th><th className="px-6 py-4 font-medium hidden md:table-cell">Reason</th>
            <th className="px-6 py-4 font-medium">Status</th><th className="px-6 py-4 font-medium text-right">Manage</th></tr></thead>
          <tbody>
            {shown.map((e) => (
              <tr key={e.id} className="border-b border-white/[0.04] text-oraya-mist hover:bg-white/[0.02] cursor-pointer" onClick={() => setSelected(e)} data-testid={`enquiry-row-${e.id}`}>
                <td className="px-6 py-4"><div className="font-medium">{e.name}</div><div className="text-oraya-slate text-xs">{e.email}</div></td>
                <td className="px-6 py-4 hidden md:table-cell text-oraya-slate">{e.reason}</td>
                <td className="px-6 py-4"><StatusPill status={e.status} /></td>
                <td className="px-6 py-4 text-right" onClick={(ev) => ev.stopPropagation()}>
                  <select value={e.status} onChange={(ev) => setStatus(e.id, ev.target.value)} data-testid={`enquiry-status-${e.id}`} className="bg-oraya-black border border-white/10 rounded-lg px-2 py-1.5 text-xs text-oraya-mist focus:border-oraya-accent focus:outline-none">
                    {STATUSES.map((s) => <option key={s} value={s} className="bg-oraya-graphite">{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {shown.length === 0 && <tr><td colSpan="4" className="px-6 py-10 text-center text-oraya-slate">No enquiries.</td></tr>}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={() => setSelected(null)} data-testid="enquiry-detail">
          <div className="bg-oraya-graphite border border-white/10 rounded-2xl w-full max-w-lg p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <StatusPill status={selected.status} />
              <span className="text-xs text-oraya-slate">{selected.id}</span>
            </div>
            <h3 className="display text-2xl font-medium text-oraya-mist mt-4">{selected.name}</h3>
            <div className="mt-4 space-y-2 text-sm text-oraya-slate">
              <p><span className="text-oraya-mist">Email:</span> {selected.email}</p>
              {selected.company && <p><span className="text-oraya-mist">Company:</span> {selected.company}</p>}
              {selected.phone && <p><span className="text-oraya-mist">Phone:</span> {selected.phone}</p>}
              <p><span className="text-oraya-mist">Reason:</span> {selected.reason}</p>
            </div>
            <p className="mt-4 text-oraya-mist/90 leading-relaxed whitespace-pre-line border-t border-white/[0.06] pt-4">{selected.message}</p>
            <button onClick={() => setSelected(null)} className="mt-6 text-sm text-oraya-slate hover:text-oraya-mist">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
